/* istanbul ignore file */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ADPResourceService } from 'digital-core';
import { Observable } from 'rxjs';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { IRegisteredDevice } from 'src/app/modules/account/components/claims-flow/claims-flow.component';
import { PGHAppLoadService } from './pgh-app-load.service';

const USE_MOCK = false;

@Injectable({
  providedIn: 'root',
})
export class GSSPAuthenticationService {
  expApiUrl: string;
  portalUrl: string;
  clientName: string;
  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
    private appLoadService: PGHAppLoadService,
    private resourceService: ADPResourceService
  ) {
    this.expApiUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl + this.preInitSettingsService.getSettings().middleWare.accountPath + 'gsspauthtoken';
    this.appLoadService.isSiteResourcesLoaded.subscribe(value => {
      if (value) {
        this.portalUrl = this.resourceService.getPortalSetting("URL_ClaimsPortal").Value;
        this.clientName = this.resourceService.getPortalSetting("Global_SourceClientName").Value;
      }
    });
  }

  postGenerateGSSPToken(dealerCode: string, certificateNumber: string, childCertificateNumbers: [string], registeredDevice: IRegisteredDevice): Observable<any> {

    // This implementation only applies to TMO where dealer code is appended to cert
    if(/^\d/.test(certificateNumber)) {
      certificateNumber = dealerCode + certificateNumber;
      childCertificateNumbers = [dealerCode + childCertificateNumbers[0]+"-1"];
    }
    const body = {
      ClientName: this.clientName,
      TokenRequestInformation: {
        DealerCode: dealerCode,
        CertificateNumber: certificateNumber,
        ChildCertificateNumbers: childCertificateNumbers,
        Product: registeredDevice == null ? null : {
          certificateNumber: childCertificateNumbers[0],
          manufacturer: registeredDevice.manufacturer,
          make: registeredDevice.manufacturer,
          model: registeredDevice.model,
          imei: '',
          serialNumber: registeredDevice.serialNumber,
          skuNumber: registeredDevice.modelIdentifier,
          imageUrl: '',
          memory: '',
          color: '',
          size: '',
          deviceType: '',
          description: '',
          riskTypeCode: '',
          riskTypeDescription: '',
          isMobile: 'false',
          name: registeredDevice.registeredItemName,
          registeredName: registeredDevice.registeredItemName,
          registeredDevices: '',
          type: registeredDevice.deviceTypeCode,
          purchaseDate: registeredDevice.purchasedDate,
          purchasePrice: registeredDevice.purchasePrice,
        }
      }
    };
    return this.http.post<IRegisteredDevice>(this.expApiUrl, body);
  }

  generateFileClaimLink(token: string) {
    return this.portalUrl + '?accessToken=' + token + '&redirectUrl=/file-claim';
  }
}
